import { Box, Button, TextField } from '@mui/material'
import React from 'react'

export default function AddContact({
    name,
    number,
    setName,
    setNumber,
    handleSubmit
}) {
  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 5, mx: 'auto', width: '70%' }}>
        <TextField
        onChange={e => setName(e.target.value)}
        value={name}
        color="secondary"
        margin="normal"
        required
        fullWidth
        label="Name"
        autoFocus
        error={name === ""}
        helperText={name === "" ? "Empty!" : " "}
        />
        <TextField
        onChange={e => setNumber(e.target.value)}
        value={number}
        color="secondary"
        margin="normal"
        required
        fullWidth
        label="Number (4168999137)"
        error={number === ""}
        helperText={number === "" ? "Empty!" : " "}
        />
        <Button
        type="submit"
        fullWidth
        variant="contained"
        color="secondary"
        sx={{ mt: 3, mb: 2 }}
        >
        Add Contact
        </Button>
    </Box>
  )
}
